import React from "react";
import { useSelector } from "react-redux";
import DashBoard from "../../Pages/DashBoard/DashBoard";
import ListUsers from "../../Pages/ListUsers/ListUsers";
import ListRoles from "../../Pages/ListRoles/ListRoles";
import ListPermissions from "../../Pages/ListPermissions/ListPermissions";
import ListDivision from "../../Pages/ListDivision/ListDivision";
import ListApplication from "../../Pages/ListApplication/ListApplication";
import ListBU from "../../Pages/ListBU/ListBU";
import ListProduct from "../../Pages/ListProduct/ListProduct";
import ListContent from "../../Pages/ListContent/ListContent";
import List3DContent from "../../Pages/List3DContents/List3DContents";
import ListApplicationVR from "../../Pages/ListApplicationVR/ListApplicationVR";
import ListContentVR from "../../Pages/ListContentVR/ListContentVR";
import AppDown from "../../Pages/AppDown/AppDown";
import Settings from "../Settings/Settings";

function Content() {
  const string = useSelector((state) => state.sidebar.string);

  return (
    <div>
      {/* Basic pages */}
      {string === "DashBoard" && <DashBoard />}
      {string === "Settings" && <Settings />}
      {string === "ListUsers" && <ListUsers />}
      {string === "ListRoles" && <ListRoles />}
      {string === "ListPermissions" && <ListPermissions />}
      {string === "ListBU" && <ListBU />}
      {string === "ListDivision" && <ListDivision />}

      {/* AR Management */}
      {string === "ListApplication" && <ListApplication />}
      {string === "ListProduct" && <ListProduct />}
      {string === "ListContent" && <ListContent />}
      {string === "List3DContent" && <List3DContent />}

      {/* VR Management */}
      {string === "ListApplicationVR" && <ListApplicationVR />}
      {string === "ListContentVR" && <ListContentVR />}

      {/* Error page */}
      {string === "AppDown" && <AppDown />}
    </div>
  );
}

export default Content;
